module.exports = __webpack_public_path__ + "img/hu-tao.e12c2a40.webp";